module.exports = __webpack_public_path__ + "static/media/better-remente.b0e3cac3.svg";